import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';

// https://github.com/okonet/react-dropzone
var Dropzone = require('react-dropzone');

export class SupplierLedgerFileUpload extends React.Component {

  static propTypes = {
    set: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
    imageSrc: PropTypes.any.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      files: [],
      invalidFile: false
    };

    this.onDrop = this.onDrop.bind(this);
    this.delete = this.delete.bind(this);
  }

  validate (file) {
    let validFileExtensions, validFileSize, typeValid;

    validFileExtensions = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/bmp',
      'image/svg+xml',
      'text/plain',
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessing',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    validFileSize = 2097152;
    typeValid = false;

    if (file.size > validFileSize) {
      return false;
    }

    for (let i = 0; i < validFileExtensions.length; i++) {
      if (file.type === validFileExtensions[i]) {
        typeValid = true;
        break;
      }
    }

    return typeValid;
  }

  delete (e) {
    e.preventDefault();
    this.setState({
      files: [],
      invalidFile: false
    });

    this.props.delete();
  }

  onDrop (files) {
    if (this.validate(files[0])) {
      this.setState({
        files: files,
        invalidFile: false,
        imageSrc: files[0].preview
      });

      this.props.set(files[0]);
    } else {
      this.setState({invalidFile: true});
    }
  }

  renderDeleteButton () {
    if (this.props.imageSrc) {
      return (
        <button className='menu-btn close-menu' onClick={this.delete}>
          <div className='cornerimage remove-link'/>
        </button>
      );
    }
  }

  render () {
    return (
      <div className='upload-supplier-ledger-file'>
        <div className='containerdiv'>
          <img src={this.props.imageSrc} alt=''/>
          {this.renderDeleteButton()}
        </div>

        <div className='new_line'/>
        <Dropzone ref='dropzone' onDrop={this.onDrop} className='drop-zone' multiple={false}>
          <div><Translate content='ADD_DEDUCTION_RECEIPT'/></div>
        </Dropzone>
        <p className={this.state.invalidFile ? 'error show' : 'error'}><Translate content='DEDUCTION_FILE_ERROR'/></p>
      </div>
    );
  }
}

export default SupplierLedgerFileUpload;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/form/supplier-ledger-file-upload.js
 **/